import { Component, OnInit, Input } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';

import { DataService } from '../../providers/data.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  providers: [ConfirmationService]
})
export class UsersComponent implements OnInit {

  // @Input() mode: string = 'new';

  now: string = new Date().toISOString();
  show_popup = false;
  loading: boolean;
  last_fetch: Date;
  headers: any;
  // TODO: should ba part of settings
  // TODO: make complex objects like swagger ...
  detail_attributes = ['id', 'ext_id', 'name', 'description', 'orig_price', 'retail_price', 'base_price', 'status'];
  base_headers: any[] = [
    { title: 'app_code', sort_field: 'id', class: 'th--normal', width: '12em' },
    { title: 'user_id', sort_field: 'ext_id', class: 'th--normal', width: '12em' },

    { title: 'name', sort_field: 'name', class: 'th--small', width: '20em' },

    { title: 'email', sort_field: 'email', class: 'th--normal', width: '20em' },
    { title: 'address', sort_field: 'address', class: 'th--normal-right', width: '15em' },
    { title: 'postalcode', sort_field: 'postalcode', class: 'th--normal-right', width: '8em' },
    { title: 'city', sort_field: 'city', class: 'th--normal-right', width: '15em' },

    { title: 'group', sort_field: 'premium_partner_type', class: 'th--small', width: '12em' },
  ];

  users: any;

  sample = "activated: null\n" +
    "address: \"strv 55\"\n" +
    "address_xtra: null\n" +
    "city: \"Adam\"\n" +
    "company: \"test\"\n" +
    "country: null\n" +
    "created: \"2018-11-22T16:08:06Z\"\n" +
    "email: \"m@kadijk.com\"\n" +
    "ext_id: \"908098098\"\n" +
    "has_other_invoice_address: false\n" +
    "id: \"5171003185430528\"\n" +
    "invoice_address: null\n" +
    "invoice_city: null\n" +
    "invoice_company: null\n" +
    "invoice_postalcode: null\n" +
    "invoice_vatnumber: null\n" +
    "invoice_vatpercentage: null\n" +
    "is_certified: false\n" +
    "is_superadmin: false\n" +
    "last_request_new_voucher_batch: null\n" +
    "latitude: null\n" +
    "longitude: null\n" +
    "loyalty_balance: null\n" +
    "loyalty_last_activity: null\n" +
    "loyalty_remote_batches: []\n" +
    "loyalty_status: null\n" +
    "loyalty_user: null\n" +
    "marketing_allowed: false\n" +
    "marketing_logo: null\n" +
    "name: \"m k\"\n" +
    "phone: null\n" +
    "postalcode: \"1099 AB\"\n" +
    "premium_partner_type: null\n" +
    "premium_partner_until: null\n" +
    "sales_district: null\n" +
    "saluation: null\n" +
    "status: null\n" +
    "updated: \"2018-11-22T16:08:06Z\"\n" +
    "voucher_batches: []\n" +
    "website: null";

  constructor(private dataService: DataService, private route: ActivatedRoute, private confirmService: ConfirmationService) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      // if(!!params['mode']) this.mode = params.mode;
      this.headers = [...this.base_headers];
      // if(this.mode == 'new'){
      //   this.headers.push(
      //     { title: '', class: 'th--edit', with: '3em' })
      // }
      this.get_users();
    });
  }

  get_users(refresh: boolean = false) {
    this.loading = true;
    this.dataService.get('user').subscribe(result =>{
        this.loading = false;
        this.last_fetch = new Date();
        this.users = result;
        // add for easy full text search ....
        for( let user of this.users){
          user.as_text = JSON.stringify(user);
        }
      },
      (err) => {
        this.loading = false;
        console.log(err);
      }
    );
  }
  
  // _handle_upload_result(prod, res) {
  //   // prod.img = res['secure_url'].replace('/v'+res['version'], '/t_m240');
  //   prod.images = [];
  //   prod.images.push( res['secure_url'].replace('/v' + res['version'], '') );
  //   // prod.img = res['secure_url']; // keep the version !
  //   prod.changed = true;
  //   this.dataService.put('user', { images: prod.images, id: prod.id}).subscribe(
  //     (saved) => {
  //       prod.uploading = false;
  //       prod.changed = false;
  //     });
  // }
  //
  // new_img_upload(prod, event) {
  //   prod.uploading = true;
  //   this.dataService.upload_imagefile_for_user(prod, event.files[0]).subscribe(
  //     (res) => {
  //       this._handle_upload_result(prod, res);
  //     });
  // }

  editUser(user, new_status) {
    user.status = 'REQUEST ' + new_status;
    this.dataService.put('user', user).subscribe(new_user => {
       user.status = new_user['status'];
       user.updated_by = new_user['updated_by'];
       user.is_mine = user.updated_by == this.dataService.current_user_name;
    }, err=>{
      user.status = 'ERROR';
    });
  }


  // createUser() {
  //   this.show_popup = true;
  // }

  // onClose(event) {
  //   this.user = undefined;
  //   this.show_popup = false;
  // }

  onNotify(event) {
    // this.presentUser(event.type, event.title, event.body);
  }

  // presentUser(type: string, title: string, body: string) {
  //   this.userservice.add({severity: type, summary: title, detail: body});
  // }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/users/users.component.ts